import { tannerBlack } from '../ThemeProvider/colors';

export const TabIndicatorStyles = {
  backgroundColor: tannerBlack,
};
